<template>
  <div class="form-group">
    <h3>La operación requiere de clave de firma</h3>
    <br/>
    <label class="labelClaveFirma">Introduzca las posiciones solicitadas de su clave de firma</label>
    <div class="claveFirma">
      <div class="providerReference"> <!--En un futuro este div se generara de manera dinamica, como el teclado virtual-->
        <input class="inputLoginComponent primeraPosicion" disabled type="text" name="firstGroup" maxlength="1" v-model="providerReference.firstGroup" required>
        <input class="inputLoginComponent" disabled type="text" name="firstGroup" maxlength="1"  v-model="providerReference.secondGroup" required>
        <input class="inputLoginComponent" disabled type="text" name="secondGroup" maxlength="1" v-model="providerReference.thirdGroup" required>
        <input class="inputLoginComponent" disabled type="text" name="fourthGroup" maxlength="1" v-model="providerReference.fourthGroup" required>
        <input class="inputLoginComponent" disabled type="text" name="fifthGroup" maxlength="1" v-model="providerReference.fifthGroup" required>
        <input class="inputLoginComponent" disabled type="text" name="sixthGroup" maxlength="1" v-model="providerReference.sixthGroup" required>
        <input class="inputLoginComponent" disabled type="text" name="seventhGroup" maxlength="1" v-model="providerReference.seventhGroup" required>
        <input class="inputLoginComponent" disabled type="text" name="eighthGroup" maxlength="1" v-model="providerReference.eighthGroup" required>
      </div>
      <div class="botonera">
        <div class="botones">
          <button type="button" v-for="num in numeros" v-bind:key="num" class="botonPantalla" @click="tecladoVirtual($event)">{{num}}</button>
        </div>
        <button type="button" class="botonBorrar" @click="borrar()">
          Borrar
        </button>
      </div>
    </div>
    <div>
    <span>
    </span>
    <!-- Boton aceptar -->
    <input type="button" class="btnPrimary separacion" @click="aceptarClave()" value="Aceptar" :disabled="isDisabled">
    <!-- Boton cancelar -->
    <input type="button" class="btnSecondary" @click="cancelar()" value="Cancelar">
    </div>
  </div>
</template>

<script>
import ProviderReference from '../models/ProviderReference';
export default {
    name : 'SignatureComponent',
    data(){
      return{
        numeros:null,
        datosSalida:null,
        mensajeError:'Algo ha ido mal, asegúrate que has introducido correctamente tus datos', //mensaje de error por defecto
        confirmacion:null,
        categoria:'Firma de la operaci\u00F3n',
        value1: null,
        value2: null,
        value3: null,
        value4: null,
        value5: null,
        value6: null,
        value7: null,
        value8: null,
        providerReference : new ProviderReference()
      }
    },
    props: {
      params: new Object(),
      datosFirma: new Object(),
      llamada: new Object(),
      queries: new Object()
    },
    computed : {
      isDisabled: function() { //aqui pondremos los campos obligatorios de nuestro form
        return  !this.providerReference.firstGroup || !this.providerReference.secondGroup || !this.providerReference.thirdGroup || !this.providerReference.fourthGroup ||
                !this.providerReference.fifthGroup || !this.providerReference.sixthGroup || !this.providerReference.seventhGroup || !this.providerReference.eighthGroup;
      }
    },
    mounted: function(){
      var arrayTeclado=new Array();
      var numActual;
      var i;
      for(i=0;i<10;i){
        numActual=Math.floor(Math.random() * 10);
        if(!arrayTeclado.includes(numActual)){
          arrayTeclado.push(numActual);
          i++;
        }
      }
      this.rellenarAsteriscos(this.datosFirma.data);
      this.numeros=arrayTeclado;
    },
    methods: {
      rellenarAsteriscos(posiciones){
        if(posiciones.indexOf("01") == -1) {
          this.providerReference.firstGroup = '*';
        }
        if(posiciones.indexOf("02") == -1) {
          this.providerReference.secondGroup = '*';
        }
        if(posiciones.indexOf("03") == -1) {
          this.providerReference.thirdGroup = '*';
        }
        if(posiciones.indexOf("04") == -1) {
          this.providerReference.fourthGroup = '*';
        }
        if(posiciones.indexOf("05") == -1) {
          this.providerReference.fifthGroup = '*';
        }
        if(posiciones.indexOf("06") == -1) {
          this.providerReference.sixthGroup = '*';
        }
        if(posiciones.indexOf("07") == -1) {
          this.providerReference.seventhGroup = '*';
        }
        if(posiciones.indexOf("08") == -1) {
          this.providerReference.eighthGroup = '*';
        }
      },
      tecladoVirtual(elemento){
        if(!this.providerReference.firstGroup){
            this.providerReference.firstGroup=elemento.target.innerHTML;
          }else if(!this.providerReference.secondGroup){
            this.providerReference.secondGroup=elemento.target.innerHTML;
          }else if(!this.providerReference.thirdGroup){
            this.providerReference.thirdGroup=elemento.target.innerHTML;
          }else if(!this.providerReference.fourthGroup){
            this.providerReference.fourthGroup=elemento.target.innerHTML;
          }else if(!this.providerReference.fifthGroup){
            this.providerReference.fifthGroup=elemento.target.innerHTML;
          }else if(!this.providerReference.sixthGroup){
            this.providerReference.sixthGroup=elemento.target.innerHTML;
          }else if(!this.providerReference.seventhGroup){
            this.providerReference.seventhGroup=elemento.target.innerHTML;
          }else if(!this.providerReference.eighthGroup){
            this.providerReference.eighthGroup=elemento.target.innerHTML;
          }
      },
      borrar(){
        if(this.providerReference.eighthGroup != '*' && this.providerReference.eighthGroup != null){
          this.providerReference.eighthGroup=null;
        }else if(this.providerReference.seventhGroup != '*' && this.providerReference.seventhGroup != null){
          this.providerReference.seventhGroup=null;
        }else if(this.providerReference.sixthGroup != '*' && this.providerReference.sixthGroup != null){
          this.providerReference.sixthGroup=null;
        }else if(this.providerReference.fifthGroup != '*' && this.providerReference.fifthGroup != null){
          this.providerReference.fifthGroup=null;
        }else if(this.providerReference.fourthGroup != '*' && this.providerReference.fourthGroup != null){
          this.providerReference.fourthGroup=null;
        }else if(this.providerReference.thirdGroup != '*' && this.providerReference.thirdGroup != null){
          this.providerReference.thirdGroup=null;
        }else if(this.providerReference.secondGroup != '*' && this.providerReference.secondGroup != null){
          this.providerReference.secondGroup=null;
        }else if(this.providerReference.firstGroup != '*' && this.providerReference.firstGroup != null){
          this.providerReference.firstGroup=null;
        }
      },
      obtenerClaveFirma(){
        var claveFirma = null;
        for (var clave in this.providerReference) {
          if(this.providerReference[clave]!= '*'){
            if(claveFirma==null){
              claveFirma = this.providerReference[clave];
            } else {
              claveFirma = claveFirma + this.providerReference[clave];
            }
          }
        }
        return claveFirma;
      },
      aceptarClave(){ //llamada al web service
          const ventana = this;
          const baseURI = this.llamada.urlEndpoint;
          var options = {
            headers: {
                'X-SIGNATURE-TRANSACTION': this.datosFirma.transactionCode,
                'X-SIGNATURE-KEY': this.obtenerClaveFirma(),
                'X-SIGNATURE-TYPE':this.datosFirma.type
            },
            params:this.queries
          };
          let loader = this.$loading.show();
          var confirmacion = null;
          if(this.llamada.metodo=='POST'){
            this.$http.post(baseURI, this.params, options)
            .then((result) => {
              this.datosSalida=result;
              confirmacion = "OK";
              ventana.$emit('aceptar', confirmacion, result);
            })
            .catch(function (error) {
              if(error.response.status != 200) {
                var codError = error.response.data.result.errors[0].errorCode;
                var descError = error.response.data.result.errors[0].errorDescription;
                var mensajeError = codError + " - " + descError;
                confirmacion = "KO";
                ventana.$emit('aceptar', confirmacion, mensajeError);
              }
            })
            .then(function () {
              loader.hide();
            });
          }else if(this.llamada.metodo=='PUT'){
            /*if(baseURI=='/api-users/users/forgotPassword'){
              options.headers['X-CHANNEL-KEY']='W'; //el olvido de password es el unico flujo fuera del portal que requeria clave de firma, queda comentado ya que se desestimo
            }*/
            this.$http.put(baseURI, this.params, options)
            .then((result) => {
              this.datosSalida=result;
              confirmacion = "OK";
              ventana.$emit('aceptar', confirmacion);
            })
            .catch(function (error) {
              if(error.response.status != 200) {
                var codError = error.response.data.result.errors[0].errorCode;
                var descError = error.response.data.result.errors[0].errorDescription;
                var mensajeError = codError + " - " + descError;
                var otp=error.response.data.result.errors[0].info;
                confirmacion = "KO";
                ventana.$emit('aceptar', confirmacion, mensajeError, otp, codError);
              }
              
            })
            .then(function () {
              loader.hide();
            });
          }else if(this.llamada.metodo=='GET'){
            this.$http.get(baseURI, options)
            .then((result) => {
              confirmacion = "OK";
              ventana.$emit('rellenarDatos', confirmacion, result);
            })
            .catch(function (error) {
              if(error.response.status != 200) {
                var codError = error.response.data.result.errors[0].errorCode;
                var descError = error.response.data.result.errors[0].errorDescription;
                var mensajeError = codError + " - " + descError;
                confirmacion = "KO";
                ventana.$emit('aceptar', confirmacion, mensajeError);
              }
            })
            .then(function () {
              loader.hide();
            });
          } else if(this.llamada.metodo=='DELETE'){
            var params = this.params;
            var headers = options.headers;
            this.$http.delete(baseURI, {headers, params})
            .then((result) => {
              this.datosSalida=result;
              confirmacion = "OK";
              ventana.$emit('aceptar', confirmacion, result);
            })
            .catch(function (error) {
              if(error.response.status != 200) {
                var codError = error.response.data.result.errors[0].errorCode;
                var descError = error.response.data.result.errors[0].errorDescription;
                var mensajeError = codError + " - " + descError;
                confirmacion = "KO";
                ventana.$emit('aceptar', confirmacion, mensajeError);
              }
            })
            .then(function () {
              loader.hide();
            });
          }
      },
      cancelar(){
        let loader = this.$loading.show();
        this.providerReference.firstGroup=null;
        this.providerReference.secondGroup=null;
        this.providerReference.thirdGroup=null;
        this.providerReference.fourthGroup=null;
        this.providerReference.fifthGroup=null;
        this.providerReference.sixthGroup=null;
        this.providerReference.seventhGroup=null;
        this.providerReference.eighthGroup=null;
        setTimeout(() => {
          loader.hide();    
        },700);
        this.$emit('cancelar');
      }
    }
}
</script>